import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import WhatsAppButton from "./components/WhatsAppButton";
import {
  AboutSection,
  ServicesSection,
  WhyChooseUsSection,
  CoreValuesSection,
  DocumentsSection,
  StatsSection,
} from "./components/Sections";
import {
  ProjectsSection,
  TrustedBySection,
  BlogSection,
  CTASection,
  ContactSection,
  Footer,
} from "./components/ProjectsBlog";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ProjectsPage from "./pages/ProjectsPage";
import ContactPage from "./pages/ContactPage";
import BlogPage, { BlogDetailPage } from "./pages/BlogPage";
import CareersPage from "./pages/CareersPage";

const HomePage = () => (
  <>
    <HeroSection />
    <AboutSection />
    <ServicesSection />
    <WhyChooseUsSection />
    <CoreValuesSection />
    <DocumentsSection />
    <StatsSection />
    <ProjectsSection />
    <TrustedBySection />
    <BlogSection />
    <CTASection />
    <ContactSection />
  </>
);

const ScrollToTop = () => {
  const { pathname } = require('react-router-dom').useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogDetailPage />} />
          <Route path="/careers" element={<CareersPage />} />
        </Routes>
        <Footer />
        <WhatsAppButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
